<template>
  <div
    class="boyo-upload"
    v-loading="isBusy"
    element-loading-text="上传中..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(255, 255, 255, 0.75)"
  >
    <el-upload class="avatar-uploader"
               :disabled="disabled || isBusy"
               :action="action"
               :headers="gettoken()"
               :show-file-list="false"
               :on-success="handleAvatarSuccess"
               :on-error="handleUploadError"
               :before-upload="beforeAvatarUpload">
      <img v-if="src"
           :src="src.split(',')[0]"
           class="avatar">
      <i v-else
         class="el-icon-plus avatar-uploader-icon"></i>
      <span class="el-upload-list__item-actions" v-if="src && !isBusy" style="position: relative;top: -55px;font-size: 32px;overflow: hidden;">
        <span
          class="el-upload-list__item-preview"
          @click.stop="handlePictureCardPreview(src)"
        >
          <i class="el-icon-zoom-in"></i>
        </span>
        <span class="el-upload-list__item-actions" v-if="src && !disabled" style="color:red">
          <span
            @click.stop="handleRemove(src)"
          >
            <i class="el-icon-delete"></i>
          </span>
        </span>
      </span>
    </el-upload>
    <image-viewer v-if="imgViewerVisible" :urlList="src.split(',')" :on-close="onClose" :imgStyle="'width:50%;height:auto'" :z-index="2100" />
  </div>
</template>

<script>
import config from '@/api/config'
import * as imageConversion from 'image-conversion'
import ImageViewer from 'element-ui/packages/image/src/image-viewer'

export default {
  name: 'BoyoUpload',
  components: {
    ImageViewer
  },
  props: {
    src: String,
    value: String,
    disabled: Boolean,
    manualSelect: {
      type: Boolean,
      default: false
    },
    /** 父级异步上传（manualSelect）时传入，与组件内 loading 合并 */
    externalLoading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      action: config.upload,
      imgViewerVisible: false,
      uploading: false
    }
  },
  computed: {
    isBusy () {
      return this.uploading || this.externalLoading
    }
  },
  watch: {
    isBusy (val) {
      this.$emit('uploading-change', val)
    }
  },
  methods: {
    gettoken () {
      const Token = JSON.parse(localStorage.token).value
      const loginTissueId = localStorage.loginTissueId
      return { Token: Token, 'X-Tissue-Id': loginTissueId }
    },
    setUploading (val) {
      this.uploading = !!val
    },
    beforeAvatarUpload (file) {
      if (this.manualSelect) {
        this.$emit('on-select-file', file, this.value)
        return false
      }
      this.setUploading(true)
      return new Promise((resolve, reject) => {
        const isSmall = file.size / 1024 / 1024 < 0.9
        if (isSmall) {
          resolve(file)
          return
        }
        imageConversion.compressAccurately(file, 500)
          .then(res => resolve(res))
          .catch(err => {
            this.setUploading(false)
            this.$message.error('图片压缩失败')
            reject(err)
          })
      })
    },
    handleAvatarSuccess (res, file, fileList) {
      this.setUploading(false)
      this.$emit('on-success', res, file, fileList, this.value)
    },
    handleUploadError () {
      this.setUploading(false)
      this.$message.error('图片上传失败')
    },
    handleRemove () {
      this.$emit('on-removeImg', this.value)
    },
    handlePictureCardPreview (src) {
      if (src) {
        this.imgViewerVisible = true
      }
    },
    onClose () {
      this.imgViewerVisible = false
    }
  }
}
</script>
<style lang="stylus" scoped>
.boyo-upload
  position relative
  display inline-block
  min-height 77px
  min-width 77px
.avatar-uploader>>> .el-upload
  border 1px dashed #d9d9d9
  border-radius 6px
  cursor pointer
  position relative
  overflow hidden
.avatar-uploader>>> .el-upload:hover
  border-color #409EFF
.avatar-uploader-icon
  font-size 28px
  color #8c939d
  width 75px
  height 75px
  line-height 75px
  text-align center
.avatar
  width 75px
  height 75px
  display block
.avatar-uploader
  height 77px
  overflow hidden
</style>



// WEBPACK FOOTER //
// src/components/BoyoUpload/index.vue